module.exports = "<div *ngIf=\"!hide\">\n  <div class=\"d-flex justify-content-end\" *ngIf=\"isChild\">\n    <!--<app-button label=\"cancelar\" color=\"white\" (click)=\"close(true)\"></app-button>-->\n    <app-button label=\"aceptar\" (click)=\"close(false)\"></app-button>\n  </div>\n  <div class=\"d-flex justify-content-end\" *ngIf=\"!isChild\">\n    <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/form/core/component/form-footer/form-footer.component.html
// module id = 1108
// module chunks = 0